<template>
  <div class="chats">
    <GlobalSpinner :is-loading="isLoading" variant="primary" />

    <!-- RGPD notice: fixed at the top, reminds agents the auto-message was sent on first contact -->
    <div v-if="showRgpd" class="rgpd-notice">
      <feather-icon icon="InfoIcon" size="13" class="rgpd-notice__icon" />
      <span>
        <strong>Message automatique envoyé au premier contact du jeune via SMS/WhatsApp :</strong>
        « Bonjour, vous êtes bien sur la ligne de la Fondation Le Refuge. Nous avons bien reçu votre message et mettons tout en œuvre pour vous répondre dans les meilleurs délais. Les messages que vous échangez avec notre équipe sont conservés uniquement le temps nécessaire à votre accompagnement, puis supprimés. Les informations que vous nous confiez sont accessibles uniquement aux personnes habilitées à vous accompagner. Pour en savoir plus sur le traitement de vos données et vos droits, consultez notre politique de confidentialité : www.le-refuge.org.  En cas d'urgence, nous vous conseillons de contacter : le 115 (hébergement d'urgence), le 15 (SAMU / urgences médicales) ou le 17 (police ou gendarmerie). »
      </span>
    </div>

    <div v-for="(group, groupIndex) in messageGroups" :key="groupIndex">
      <div class="chat" :class="{ 'chat-left': group.senderType === 1 }">
        <div v-if="group.senderType === 2" class="chat-avatar">
          <initials-avatar v-if="group.user" class="avatar-border-2 box-shadow-1" variant="transparent" size="36"
                           :family-name="group.user.familyName" :given-name="group.user.givenName" :show-title="true" />
        </div>
        <div class="chat-body">
          <div v-for="message in group.messages" :key="message.id" class="chat-content d-flex">
            <div class="d-flex align-content-center">
              <div class="align-items-start align-content-center">
                <feather-icon v-if="message.icon" class="m-50" :icon="message.icon" size="28" />
              </div>
              <div class="d-flex flex-column">
                <p v-if="message.type === 3" class="text-danger">
                  Appel manqué
                </p>
                <p v-else-if="message.type === 4">
                  Appel: {{ convertHMS(message.callDuration) }}
                </p>
                <message-content :message="message" />
                <p v-if="message.type === 3 && message.senderType === 1" :class="getMissedCallLabel(message.callInfoEnum).colorClass">
                  {{ getMissedCallLabel(message.callInfoEnum).label }}
                  <feather-icon :icon="getMissedCallLabel(message.callInfoEnum).icon" class="ml-50" size="16" />
                </p>
                <small class="text-right">{{ formatDate(message.date) }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate, convertHMS } from '@core/utils/filter'
import InitialsAvatar from '@/components/InitialsAvatar.vue'
import MessageContent from './MessageContent.vue'

export default {
    components: {
        InitialsAvatar,
        MessageContent,
    },
    props: {
        messages: {
            type: Array,
            required: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        showRgpd: {
            type: Boolean,
            default: false,
        },
    },
  setup() {
    const getMissedCallLabel = callInfoEnum => {
      switch (callInfoEnum) {
        case 1:
          return { label: 'Appel manqué sans message vocal', colorClass: 'text-danger', icon: 'PhoneMissedIcon' }
        case 2:
          return { label: 'Appel manqué avec message vocal', colorClass: 'text-warning', icon: 'VoicemailIcon' }
        case 3:
          return { label: 'Message vocal écouté', colorClass: 'text-success', icon: 'HeadphonesIcon' }
        case 4:
          return { label: 'Message vocal supprimé', colorClass: 'text-muted', icon: 'Trash2Icon' }
        default:
          return { label: 'Appel manqué', colorClass: 'text-danger', icon: 'PhoneMissedIcon' }
      }
    }
        return {
            formatDate,
            convertHMS,
            getMissedCallLabel,
        }
    },
    computed: {
        messageGroups() {
            const groups = []
            let currentGroup = {
                messages: [],
                senderType: 1,
                user: null,
                userId: null,
            }
            this.messages
                .map(message => {
                    let icon = null
                    switch (message.type) {
                        case 3:
                            icon = 'PhoneMissedIcon'
                            break
                        case 4:
                            icon = 'PhoneCallIcon'
                            break
                        case 5:
                            icon = 'AlertCircleIcon'
                            break
                        default:
                            break
                    }
                    return { ...message, icon }
                })
                .reverse()
                .forEach(message => {
                    if (message.userId === currentGroup.userId && message.senderType === currentGroup.senderType) {
                        currentGroup.messages.push(message)
                    } else {
                        if (currentGroup.messages.length > 0) {
                            groups.push(currentGroup)
                        }
                        currentGroup = {
                            messages: [message],
                            senderType: message.senderType,
                            user: message.user,
                            userId: message.userId,
                        }
                    }
                })
            if (currentGroup.messages.length > 0) {
                groups.push(currentGroup)
            }
            return groups
        },
    },
}
</script>

<style scoped>
.spinner-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}
.user-chats {
  position: relative;
  height: 100%;
}
.text-voicemail {
    font-size: 0.9em;
    color: #ffb300 !important;
}
</style>

<style>
.rgpd-notice {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  background-color: rgba(22, 181, 234, 0.07);
  border: 1px solid rgba(22, 181, 234, 0.25);
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  margin: 0 0 1rem 0;
  font-size: 0.74rem;
  color: #4a5568;
  line-height: 1.5;
}
.rgpd-notice__icon {
  color: #16b5ea;
  flex-shrink: 0;
  margin-top: 2px;
}
.rgpd-notice strong {
  color: #2d3748;
  display: block;
  margin-bottom: 0.15rem;
}
/* dark mode */
.dark-layout .rgpd-notice {
  background-color: rgba(22, 181, 234, 0.1);
  border-left-color: rgba(22, 181, 234, 0.5);
  color: #a6b0cf;
}
.dark-layout .rgpd-notice strong {
  color: #d4e6ff;
}
</style>
